import React from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import {Container, Row, Col} from './BootstrapGrid';
import {Headline, Subheading} from './Typography';


const GetInTouchSection_ = (props) => (
  <div  style={{backgroundColor: props.muiTheme.palette.canvasColor,
                color: props.muiTheme.palette.textColor}}>
    <Container>
      <Row>
        <Col
          style={{height: "300px"}}
          cols={12} align="middle">
          <div style={{
              textAlign: "center",
              position: 'relative',
              top: '50%',
              transform: 'translateY(-50%)'
            }}>

            <Headline alternateColor={false}>Need to get in touch?</Headline>
            <Subheading alternateColor={false}>
              <span className='unselectable'>Reach us at </span>
              help@homegalleryproject.com
              <span className='unselectable'>.</span></Subheading>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
)

const GetInTouchSection = muiThemeable()(GetInTouchSection_);

export default GetInTouchSection;



// WEBPACK FOOTER //
// ./src/GetInTouchSection.js